import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .factory("frameworkService", ["authService", "tenantResource", "$http", "$location", "$localStorage", "$rootScope", "$translate", "$window", frameworkService]);
    function frameworkService(authService, tenantResource, $http, $location, $localStorage, $rootScope, $translate, $window) {
        var frameworkServiceFactory = {
            data: {
                slideAdmin: true
            }
        };
        function updateData() {
            if (frameworkServiceFactory.data.tenant.id === 0)
                return;
            onResize();
            if ($localStorage.selectedLanguage) {
                frameworkServiceFactory.data.selectedLanguage = $localStorage.selectedLanguage;
            }
            else {
                frameworkServiceFactory.data.selectedLanguage = {
                    culture: "",
                    name: ""
                };
            }
            if (frameworkServiceFactory.data.tenantFeatures) {
                frameworkServiceFactory.data.tenantFeatures.inventory = frameworkServiceFactory.data.tenant.tenantFeaturesStorefrontInventoryEnabled; // && authService.authentication.hasInventory;
                frameworkServiceFactory.data.tenantFeatures.hasSkillCheck = authService.authentication.hasSkillCheck;
            }
            $rootScope.$broadcast("RefreshUserNotifications");
        }
        $rootScope.$on("hideAdminMenu:updated", function () {
            onResize();
        });
        function onResize() {
            var showAdmin = $window.innerWidth >= 1024 && !frameworkServiceFactory.data.hideAdminMenu;
            //frameworkServiceFactory.data.minify = $window.innerWidth < 992; 2024-04-12 remove minified version of menu
            frameworkServiceFactory.data.showAdmin = showAdmin;
        }
        frameworkServiceFactory.data.tenantFeatures = {
            advancedCatalog: false,
            advancedCatalogCategories: false,
            advancedCatalogHomePageCategories: false,
            advancedCatalogHomePageFeatured: false,
            advancedCatalogHomePageRecommended: false,
            advancedCatalogHomePageMostPopular: false,
            catalog: false,
            ceCredits: false,
            dashboard: false,
            forums: false,
            gamificationPointSystem: false,
            gamificationTierSystem: false,
            gamificationLeaderboardSystem: false,
            gamification: false,
            inventory: false,
            impersonation: false,
            multiLanguage: false,
            openBadges: false,
            organization: false,
            selfRegistration: false,
            storefront: false,
            hasSkillCheck: false
        };
        frameworkServiceFactory.data.isFrameworkLoaded = false;
        function init(callback) {
            frameworkServiceFactory.data.tenantResourceObject = tenantResource.getSettings().$promise
                .then(function (result) {
                if (result.id === undefined || result.id === 0) {
                    if (callback)
                        callback(result);
                    frameworkServiceFactory.data.isFrameworkLoaded = true;
                    frameworkServiceFactory.data.tenant = result;
                    frameworkServiceFactory.data.quickLinksOpen = false;
                    return;
                }
                frameworkServiceFactory.data.tenantFeatures = {
                    advancedCatalog: result.tenantFeaturesAdvancedCatalogEnabled,
                    advancedCatalogCategories: result.tenantFeaturesAdvancedCatalogCategoriesEnabled,
                    advancedCatalogHomePageCategories: result.tenantFeaturesAdvancedCatalogHomePageCategoriesEnabled,
                    advancedCatalogHomePageFeatured: result.tenantFeaturesAdvancedCatalogHomePageFeaturedEnabled,
                    advancedCatalogHomePageRecommended: result.tenantFeaturesAdvancedCatalogHomePageRecommendedEnabled,
                    advancedCatalogHomePageMostPopular: result.tenantFeaturesAdvancedCatalogHomePageMostPopularEnabled,
                    catalog: result.tenantFeaturesCatalogEnabled,
                    catalogVisible: result.tenantFeaturesCatalogEnabled || result.tenantFeaturesStorefrontEnabled,
                    catalogAdvancedVisible: result.tenantFeaturesStorefrontEnabled && result.tenantFeaturesAdvancedCatalogEnabled,
                    catalogBasicVisible: (result.tenantFeaturesCatalogEnabled || result.tenantFeaturesStorefrontEnabled) && !(result.tenantFeaturesStorefrontEnabled && result.tenantFeaturesAdvancedCatalogEnabled),
                    catalogCategoriesVisible: result.tenantFeaturesAdvancedCatalogCategoriesEnabled && result.tenantFeaturesStorefrontEnabled && result.tenantFeaturesAdvancedCatalogEnabled,
                    catalogExclusiveProductsVisible: false,
                    catalogHomePageVisible: result.tenantFeaturesStorefrontEnabled && result.tenantFeaturesAdvancedCatalogEnabled && (result.tenantFeaturesAdvancedCatalogHomePageFeaturedEnabled || result.tenantFeaturesAdvancedCatalogHomePageRecommendedEnabled),
                    ceCredits: result.tenantFeaturesCECreditsEnabled,
                    dashboard: result.tenantFeaturesDashboardEnabled,
                    forums: result.tenantFeaturesForumsEnabled,
                    gamificationPointSystem: result.tenantFeaturesGamificationPointSystemEnabled,
                    gamificationTierSystem: result.tenantFeaturesGamificationTierSystemEnabled,
                    gamificationLeaderboardSystem: result.tenantFeaturesGamificationLeaderboardSystemEnabled,
                    gamification: result.tenantFeaturesGamificationEnabled,
                    inventory: result.tenantFeaturesStorefrontInventoryEnabled,
                    impersonation: result.tenantFeaturesImpersonationEnabled,
                    multiLanguage: result.enabledLocalizations.length > 1,
                    openBadges: result.tenantFeaturesOpenBadgesEnabled,
                    organization: result.tenantFeaturesOrganizationEnabled,
                    selfRegistration: result.tenantFeaturesSelfRegistrationEnabled,
                    storefront: result.tenantFeaturesStorefrontEnabled,
                    hasSkillCheck: authService.authentication.hasSkillCheck
                };
                //separating for clarity
                if (frameworkServiceFactory.data.tenantFeatures.catalogAdvancedVisible) {
                    frameworkServiceFactory.data.tenantFeatures.catalogExclusiveProductsVisible = result.tenantFeaturesLimitProductsToGroups || result.tenantFeaturesLimitProductsToOrganizations;
                }
                frameworkServiceFactory.data.tenant = result;
                frameworkServiceFactory.data.storefrontCurrency = result.storefrontCurrency ? result.storefrontCurrency : "CAD";
                $http.get(result.bigLogoUrl, { noAuth: true }).then(function () {
                    //preload logo;
                }, function () {
                    console.log('error loading logo.');
                });
                //GOOGLE
                frameworkServiceFactory.data.sbGoogleAnalyticsCode = "G-F656HCNFP3";
                if ($location.$$host.indexOf("localhost") !== -1)
                    frameworkServiceFactory.data.sbGoogleAnalyticsCode = "";
                else if ($location.$$host.indexOf("skillbuilder-uat.com") !== -1)
                    frameworkServiceFactory.data.sbGoogleAnalyticsCode = "G-9HCBMN1J47"; //G-LNLJ8GZ9PD is UAT
                if (result.googleAnalyticsCode)
                    frameworkServiceFactory.data.googleAnalyticsCode = result.googleAnalyticsCode;
                //does the tenant have your saved language? if not, use browser language and then tenant default
                var locale;
                // Saved Language
                if ($localStorage.selectedLanguage)
                    locale = _.find(result.enabledLocalizations, { "languageCulture": $localStorage.selectedLanguage.culture });
                // Browser Languages
                // ReSharper disable once UsageOfPossiblyUnassignedValue
                if (!locale) {
                    //Browser Accept-Languages
                    if ($window.navigator.languages) {
                        for (var i = 0; i < $window.navigator.languages.length; i++) {
                            locale = _.find(result.enabledLocalizations, { "languageCulture": $window.navigator.languages[i] });
                            if (locale)
                                break;
                        }
                    }
                    else {
                        //Browser UI Language
                        locale = _.find(result.enabledLocalizations, { "languageCulture": $window.navigator.language || $window.navigator.userLanguage });
                    }
                }
                //Site Default Language
                if (!locale) {
                    locale = {
                        id: result.defaultLocalization.id,
                        languageCulture: result.defaultLocalization.languageCulture,
                        name: result.defaultLocalization.name
                    };
                }
                setLocale(locale.languageCulture, locale.id, locale.name, function () {
                    if (callback)
                        callback(result);
                });
                onResize();
                frameworkServiceFactory.data.isFrameworkLoaded = true;
            })
                .catch(angular.noop);
        }
        function setLocale(culture, id, name, callback) {
            var parsedId = parseInt(id);
            var currentCulture = $translate.proposedLanguage() || $translate.use();
            var selectedLanguage = { culture: culture, name: name, id: parsedId };
            frameworkServiceFactory.data.selectedLanguage = selectedLanguage;
            $localStorage.currentLocalizationId = parsedId;
            $localStorage.selectedLanguage = selectedLanguage;
            if (currentCulture !== culture) {
                $translate.use(culture).then(function () {
                    $translate.refresh();
                    if (callback)
                        callback();
                });
            }
            else {
                if (callback)
                    callback();
            }
        }
        function reloadPages() {
            if (!frameworkServiceFactory.data.isFrameworkLoaded)
                return;
            tenantResource.getSettingPages().$promise
                .then(function (result) {
                if (result)
                    frameworkServiceFactory.data.tenant.pages = result.value;
            })
                .catch(angular.noop);
        }
        $window.onresize = function () {
            $rootScope.$apply(function () {
                onResize();
            });
        };
        function saveCart(cart) {
            $localStorage.storefrontCart3 = cart;
        }
        function getCart() {
            return $localStorage.storefrontCart3;
        }
        frameworkServiceFactory.init = init;
        frameworkServiceFactory.reloadPages = reloadPages;
        frameworkServiceFactory.setLocale = setLocale;
        frameworkServiceFactory.updateData = updateData;
        frameworkServiceFactory.getCart = getCart;
        frameworkServiceFactory.saveCart = saveCart;
        return frameworkServiceFactory;
    }
}());
